<template>
    <div v-if="this.$store.state.device.isMobile">
      <navbarTop></navbarTop>
      <div style="width: 100%; height: 100%; position: absolute;">
        <div style="height: 100%; padding-top: 25%; background-color: #ffffff;">
          <!--<div class="circleIMG" :style="{'background': this.$store.state.device.color, 'background-image': 'linear-gradient('+this.$store.state.device.color+', #2B2D42 150%)'}">
          </div>-->
           <img class="logo" :src="this.$store.state.device.image">
          <div style="margin: 10% 0 10% 0"><b style="color: #2B2B2B; font-size: 18px;">{{this.$store.state.device.organization}}</b></div>
          <div>
            <label style="color: #2B2B2B;"><b>{{ $t('pages.Profile.Email') }} </b>{{email}}</label>
          </div>
          <button v-on:click="forgotPasswordButton" class="btnSendEmail">{{ $t('pages.Profile.SendEmail') }}</button>
          <div style="text-align: left;margin-top: 10%;margin-left: 10%;">
            <a v-on:click="back"><i style="margin-right: 10px;" class="fas fa-chevron-left"></i>{{ $t('standard.back') }}</a>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import {forgotPassword} from "../api/Auth/apiAuth";
  import navbarTop from "../components/navbarTop";
  const pt = require('../translations/pt-PT/pt-PT');
  const en = require('../translations/en-GB/en-GB');
  export default {
    name: "profile",
    components: {navbarTop},
    data() {
      return {
        email: ""
      };
    },
    methods: {
      back: function() {
        this.$router.push('/dashboard');
      },
      forgotPasswordButton: function () {
        let spinner = this.$loading.open();
        forgotPassword({email: localStorage.getItem('email')}).then(response => {
          spinner.close();
          if(this.$i18n.locale()=='pt') this.$toast.open(pt.pages.Profile.messageSent);
          if(this.$i18n.locale()=='en') this.$toast.open(en.pages.Profile.messageSent);
        }).catch((error) => {spinner.close();this.$toast.open({message: 'Algo correu mal', type: 'is-danger'})} );
      },
    },
    mounted() {
      this.email = localStorage.getItem('email');
    }
  };
</script>

<style>
  .logo {
    width: 40%;
  }
  @media (max-height: 750px) {
    .circleIMG {
      margin: auto;
      width: 45%;
      height: 35%;
      -webkit-border-radius: 50%;
    }
  }
  @media (min-height: 750px) {
    .circleIMG {
      margin: auto;
      width: 45%;
      height: 28%;
      -webkit-border-radius: 50%;
    }
  }
  @media (max-width: 325px){
    .btnSendEmail {
      height: 55px;
      width: 95%;
      background: #2B2D42 0% 0% no-repeat padding-box;
      border-radius: 32px;
      color: white;
      border: none;
      letter-spacing: 0.85px;
      margin-top: 10%;
      padding: 0;
    }
  }
  @media (min-width: 325px){
    .btnSendEmail {
      height: 55px;
      width: 85%;
      background: #2B2D42 0% 0% no-repeat padding-box;
      border-radius: 32px;
      color: white;
      border: none;
      letter-spacing: 0.85px;
      margin-top: 10%;
      padding: 0;
    }
  }
</style>
